import gql from 'graphql-tag';
const query = gql`
mutation countOfIIA($ErasmusCode: String!, $Status: [String], $AcademicYear: [String], $PartnerEC: [String], $ModifiedSince: String, $Search: String) {
  countOfIIA(ErasmusCode: $ErasmusCode, Status: $Status, AcademicYear: $AcademicYear, PartnerEC: $PartnerEC, ModifiedSince: $ModifiedSince, Search: $Search) {    
    count
  }
}
`;
export { query };
